import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const SocialMediaEditor = () => {
  const [socialLinks, setSocialLinks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadSocialLinks();
  }, []);

  const loadSocialLinks = async () => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/social-media`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setSocialLinks(data.data);
      }
    } catch (error) {
      console.error('Error loading social links:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async (link) => {
    setSaving(true);
    setMessage('');

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/social-media/${link.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          url: link.url,
          is_active: link.is_active,
          display_order: link.display_order
        })
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حفظ رابط التواصل الاجتماعي بنجاح!');
        setTimeout(() => setMessage(''), 3000);
        loadSocialLinks();
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      setMessage('خطأ في الاتصال');
      console.error('Save error:', error);
    } finally {
      setSaving(false);
    }
  };

  const handleChange = (id, field, value) => {
    setSocialLinks(prev => prev.map(link => 
      link.id === id ? { ...link, [field]: value } : link
    ));
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>إدارة روابط التواصل الاجتماعي</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
      </div>

      <div className="editor-items-list">
        {socialLinks.map((link) => (
          <div key={link.id} className="editor-item-card">
            <div className="editor-item-content" style={{ flex: 1 }}>
              <h4>{link.platform}</h4>
              <div className="editor-form-group" style={{ marginTop: '15px' }}>
                <label>رابط التواصل الاجتماعي *</label>
                <input
                  type="url"
                  value={link.url || ''}
                  onChange={(e) => handleChange(link.id, 'url', e.target.value)}
                  placeholder="https://www.facebook.com"
                  style={{ width: '100%' }}
                />
              </div>
              <div style={{ display: 'flex', gap: '15px', marginTop: '15px' }}>
                <div className="editor-form-group" style={{ flex: 1 }}>
                  <label>ترتيب العرض</label>
                  <input
                    type="number"
                    value={link.display_order || 0}
                    onChange={(e) => handleChange(link.id, 'display_order', parseInt(e.target.value) || 0)}
                  />
                </div>
                <div className="editor-form-group" style={{ flex: 1 }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={link.is_active}
                      onChange={(e) => handleChange(link.id, 'is_active', e.target.checked)}
                      style={{ marginLeft: '10px' }}
                    />
                    {' '}نشط
                  </label>
                </div>
              </div>
            </div>
            <div className="editor-item-actions">
              <button 
                className="editor-btn-sm editor-btn-edit" 
                onClick={() => handleSave(link)}
                disabled={saving}
              >
                {saving ? 'جاري الحفظ...' : 'حفظ'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialMediaEditor;

